import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@ui/app/store';

export interface CpgRagUIState {
    selectedDocIds: string[];
    disclaimerDismissed: boolean;
}

const initialState: CpgRagUIState = {
    selectedDocIds: [],
    disclaimerDismissed: false,
};

const cpgRagSlice = createSlice({
    name: 'cpgRag',
    initialState,
    reducers: {
        setSelectedDocIds(state, action: PayloadAction<string[]>) {
            state.selectedDocIds = action.payload;
        },
        dismissDisclaimer(state) {
            state.disclaimerDismissed = true;
        },
    },
});

export const { setSelectedDocIds, dismissDisclaimer } = cpgRagSlice.actions;

export const selectSelectedDocIds = (state: RootState) => state.cpgRag.selectedDocIds;
export const selectDisclaimerDismissed = (state: RootState) => state.cpgRag.disclaimerDismissed;

export default cpgRagSlice.reducer;
